import { IUnitServiceHistoryDto, IUnitServiceHistoryInputDto } from 'api/api';
import actionCreatorFactory from 'typescript-fsa';
import { constants } from './constants';

const actionCreator = actionCreatorFactory('unit-service-history');

export const getUnitServiceHistoriesAction = actionCreator.async<undefined, IUnitServiceHistoryDto[]>(
	constants.GET_UNIT_SERVICE_HISTORIES
);

export const getLatestUnitServiceHistoriesAction = actionCreator.async<{unitId: number}, IUnitServiceHistoryDto[]>(
	constants.GET_LATEST_UNIT_SERVICE_HISTORIES
);

export const createUnitServiceHistoryAction = actionCreator.async<IUnitServiceHistoryInputDto, IUnitServiceHistoryDto>(
	constants.CREATE_UNIT_SERVICE_HISTORY
);

